import styled from 'styled-components'
import colorsOptions from '../stories/fundamentals/colors-styles/constants'
import projectThumbnail from '@images/project_thumbnail.jpg'
import {
  textStyleSizeOptions,
  textStyleSizeStyleOptions,
  textStyleWeightOptions,
  textStyleWeightStyleOptions
} from '../stories/fundamentals/text-styles/constants'

export const TileCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 255px;
  min-height: 300px;
  height: 100%;
  padding: 1rem;
  border-radius: 16px;
  background-color: ${colorsOptions.greys.white};
  border: 1px solid ${colorsOptions.greys['grey-20']};
  flex: 0 0 auto;
  cursor: pointer;

  &:hover {
    background-color: ${colorsOptions.greys['grey-05']};
  }

  &:active {
    background-color: ${colorsOptions.greys['grey-10']};
  }

  ${({ isSelected }) =>
    isSelected &&
    `
    background-color: ${colorsOptions.docuToolsOrange['dt-10']};
    border: 2px solid ${colorsOptions.docuToolsOrange['dt-40']};

    &:hover {
      background-color: ${colorsOptions.docuToolsOrange['dt-10']};
    }

    &:active {
      background-color: ${colorsOptions.docuToolsOrange['dt-10']};
    }
  `}
`

// Header

export const HeaderButtons = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 0.5rem;
`

export const TileImage = styled.div`
  width: 100%;
  height: 170px;
  padding: 0.5rem;
  position: relative;
  display: flex;
  flex-direction: column;
  border-radius: 8px;

  background-image: ${({ disabled, background }) =>
    disabled
      ? `
          linear-gradient(
            rgba(255, 255, 255, 0.5),
            rgba(255, 255, 255, 0.5)
          ),
          url(${background}),
          url(${projectThumbnail})
        `
      : `
          url(${background}),
          url(${projectThumbnail})
        `};

  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  margin-bottom: 2rem;
`

export const HeaderButtonsLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

export const HeaderButtonsRight = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

export const TileFolderIconContainer = styled.div`
  width: 100%;
  height: 190px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const TileFolderHeaderOverlay = styled.div`
  position: absolute;
  top: 0.5rem;
  left: 0.5rem;
  right: 0.5rem;
`

// Content

export const TileTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`

export const TitleTitle = styled.span`
  color: ${({ disabled }) =>
    disabled
      ? colorsOptions.greys['grey-40']
      : colorsOptions.greys['grey-100']};
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]};
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-700']]};
  display: -webkit-box;
  -webkit-line-clamp: 2; /* número de linhas */
  -webkit-box-orient: vertical;
  overflow: hidden;
`

export const TileDescription = styled.span`
  color: ${({ disabled }) =>
    disabled
      ? colorsOptions.greys['grey-40']
      : colorsOptions.greys['grey-100']};
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-S']]};
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-500']]};
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
`

// MetaData

export const MetaDataContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  flex-wrap: wrap;
`

export const MetaDataItemContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.25rem;

  ${({ disabled }) =>
    disabled &&
    `
    & path {
      stroke: ${colorsOptions.greys['grey-40']}
    }
  `}
`

export const MetaDataText = styled.span`
  min-width: 25px;
  display: flex;
  align-items: center;
  color: ${({ disabled }) =>
    disabled
      ? colorsOptions.greys['grey-40']
      : colorsOptions.greys['grey-100']};
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-XS']]};
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-600']]};
  line-height: 0;
`

export const RoleBagdeContainer = styled.div`
  width: fit-content;
  padding-bottom: 0.25rem;
`
